import Swiper from "swiper";

function initProductQueryResults(){
	$('.js-product-query-results-slider').each(function(index) {
		let $this = $(this);
		let slidesToShow = $(this).data('slides-shown');
		let parentWrapper = $this.parents('.product-query-results__wrapper');
		parentWrapper.find('.product-query-results__navigation').addClass('product-query-results__navigation-' + index);
		parentWrapper.find('.product-query-results__counter').addClass('product-query-results__counter-' + index);
		$this.addClass('product-query-results-' + index);

		let pqrSliderList = [];
		let $counterContainer = $(`.product-query-results__counter-${index}`);

		let pqrSlider = new Swiper('.product-query-results-' + index, {
			slidesPerView: slidesToShow,
			speed: 400,
			spaceBetween: 20,
			centeredSlides: false,
			loop: false,
			simulateTouch: true,

			navigation:  {
				nextEl: `.product-query-results__navigation-${index} .swiper-button-next`,
				prevEl: `.product-query-results__navigation-${index} .swiper-button-prev`
			},

			on: {
				init: function (swiper) {
					$counterContainer.text(`${swiper.activeIndex + 1}/${swiper.slides.length}`)
				},
				slideChange: function (swiper) {
					$counterContainer.text(`${swiper.activeIndex + 1}/${swiper.slides.length}`);
				}
			}
		});

		pqrSliderList.push(pqrSlider);
		pqrSlider.init();
	});
}

export function init() {
	initProductQueryResults();
}
